import { createReducer, createAction } from "redux-act";

import { DEFAULT_TABLE_HEIGHT } from "../../modules/Table/constants";

export const reducerName = "layout";

export type BottomState = "fullscreen" | "opened" | "none";

export type LayoutState = {
  bottomState?: BottomState;
  bottomHeight?: number;
  panelWidth?: number;
  showMapLegend?: boolean;
  isVisibleAdditionControl?: boolean;
  isNirvanaMode?: boolean;
  isPresentationMode?: boolean;
};

const initialState: LayoutState = {
  bottomState: "none",
  bottomHeight: DEFAULT_TABLE_HEIGHT,
  panelWidth: 0,
  showMapLegend: false,
  isVisibleAdditionControl: false,
  isNirvanaMode: false,
  isPresentationMode: false,
};

export const closeBottomContainer = createAction("layout/close-bottom-container");
export const openBottomContainer = createAction("layout/open-bottom-container");
export const expandBottomContainer = createAction("layout/expand-bottom-container");
export const resizeBottomContainer = createAction<number>("layout/resize-bottom-container");
export const resizePanelContainer = createAction<number>("layout/resize-panel-container");
export const toggleMapLegend = createAction("layout/toggle-map-legend");
export const setAdditionControlVisibility = createAction<boolean>("layout/toggle-additional-control");
export const toggleNirvanaMode = createAction("layout/toggle-nirvana-mode");
export const togglePresentationMode = createAction("layout/toggle-presentation-mode");

export const reducer = createReducer({}, initialState);

reducer.on(closeBottomContainer, state => ({ ...state, bottomState: "none" }));
reducer.on(openBottomContainer, state => ({ ...state, bottomState: "opened" }));
reducer.on(expandBottomContainer, state => ({ ...state, bottomState: "fullscreen" }));
reducer.on(resizeBottomContainer, (state, bottomHeight) => ({ ...state, bottomHeight }));
reducer.on(resizePanelContainer, (state, panelWidth) => ({ ...state, panelWidth }));
reducer.on(toggleMapLegend, state => ({ ...state, showMapLegend: !state.showMapLegend }));
reducer.on(toggleNirvanaMode, state => ({ ...state, isNirvanaMode: !state.isNirvanaMode }));
reducer.on(togglePresentationMode, state => ({ ...state, isPresentationMode: !state.isPresentationMode }));
reducer.on(setAdditionControlVisibility, (state, isVisible: boolean) => ({
  ...state,
  isVisibleAdditionControl: isVisible,
}));
